export const iconFieldPreset = {
  iconfield: {
    icon: {
      color: 'var(--neutral--40)',
    },
    css: () => `
      .p-iconfield .p-inputicon {
        display: flex;
        align-items: center;
      }

      .p-iconfield .p-inputicon .toggle-password {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: var(--neutral--40);
        transition: color 0.2s ease;
      }

      .p-iconfield .p-inputicon .toggle-password:hover {
        color: var(--neutral--60);
      }

      .p-iconfield .p-inputicon .toggle-password i {
        font-size: 18px;
      }
    `,
  },
};
